(function() {
  'use strict';
  
  const BODY_CLASS = 'destini-popup-open';
  
  function checkDestiniPopup() {
    const locator = document.querySelector('.destini-locator-class');
    if (!locator || !locator.shadowRoot) return false;
    
    const overlay = locator.shadowRoot.querySelector('.chakra-modal__overlay');
    return overlay !== null;
  }
  
  function updateBodyClass() {
    document.body.classList.toggle(BODY_CLASS, checkDestiniPopup());
  }
  
  // Watch for the locator element first
  const documentObserver = new MutationObserver(() => {
    const locator = document.querySelector('.destini-locator-class');
    
    if (locator && locator.shadowRoot && !locator._destiniObserverAttached) {
      locator._destiniObserverAttached = true;
      
      // Watch shadow DOM for modal changes
      const shadowObserver = new MutationObserver(updateBodyClass);
      shadowObserver.observe(locator.shadowRoot, {
        childList: true,
        subtree: true
      });
      
      updateBodyClass();
    }
  });
  
  documentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Initial check
  updateBodyClass();
})();

(function() {
  'use strict';
  
  function injectDestiniStyles() {
    const locator = document.querySelector('.destini-locator-class');
    if (!locator || !locator.shadowRoot) return;
    
    // Check if already injected
    if (locator.shadowRoot.querySelector('#custom-destini-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'custom-destini-styles';
    style.textContent = `
      .chakra-button.destini-css-1z3t03 {
        min-width: 100% !important;
        min-height: 60px !important;
        font-family: var(--co-font-2) !important;
        font-weight: 400 !important;
        font-size: 24px !important;
        cursor: pointer !important;
      }
      .chakra-button.destini-css-1z3t03:hover {
        color: #773D22 !important;
      }
    `;
    
    locator.shadowRoot.appendChild(style);
  }
  
  // Watch for the element
  const observer = new MutationObserver(injectDestiniStyles);
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Initial attempt
  injectDestiniStyles();
})();